import ConfirmModal from 'components/ConfirmModal'
import OrderContext from 'pages/Order/_context'
import PropTypes from 'prop-types'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { cancelDriver } from 'state/Orders'
import { Alerts } from 'utils'

export default function CancelDriverModal({ show, doClose }) {
	const { t }    = useTranslation()
	const dispatch = useDispatch()
	const order    = useContext(OrderContext)

	async function doSubmit() {
		await dispatch(cancelDriver(order.id))
			.then(() => Alerts.success(t('The driver request has been canceled.'))) //redundant but requested by stakeholders
			.finally(doClose)
	}

	return 	<ConfirmModal {...{ show, doClose, doSubmit }} dangerous size=""
	                      title={t('Cancel driver request')}
	                      cancelText={t('No, go back')}
	                      confirmTexts={[t('Yes, cancel'), t('Canceling')]}
	                      children={t('Do you want to cancel the {{deliveryCompany}} delivery?', { deliveryCompany: order.shipday.third_party_name })}
	/>
}

CancelDriverModal.propTypes = {
	show   : PropTypes.bool.isRequired,
	doClose: PropTypes.func.isRequired,
}
